/**
 * Premiers pas : étapes de configuration d'une nouvelle clinique (pour son
 * responsable) ou de la plateforme (pour son administrateur). Les étapes sont
 * vérifiées par le serveur sur les données réelles.
 */
import { reactive } from 'vue'
import api from '@/api'
import store from '@/store'

export const etatDemarrage = reactive({ donnees: null, le: 0 })

/** Responsable de clinique ou administrateur de la plateforme. */
export function concerneParDemarrage() {
  if (store.getters.isPlatformGestionnaire) return false
  return store.getters.isPlatformAdmin || store.getters.isSuperAdmin
}

/** Page des premiers pas pour l'utilisateur connecté. */
export function routeDemarrage() {
  return store.getters.isPlatformAdmin ? 'plateforme_demarrage' : 'premiers_pas'
}

/** Recharge les étapes (au plus toutes les 20 s, sauf `force`). */
export async function chargerDemarrage(force = false) {
  if (!concerneParDemarrage()) return null
  if (!force && etatDemarrage.donnees && Date.now() - etatDemarrage.le < 20000) return etatDemarrage.donnees
  try {
    const r = await api.custom(store.getters.isPlatformAdmin ? 'plateforme/demarrage' : 'demarrage', 'GET')
    etatDemarrage.donnees = r.data
    etatDemarrage.le = Date.now()
  } catch (e) {
    // Sans réponse (abonnement échu, coupure) : pas de bandeau ni de redirection
  }
  return etatDemarrage.donnees
}

/**
 * À la première page ouverte après la connexion : s'il reste des étapes
 * obligatoires, on montre les premiers pas (une fois par session et par compte).
 */
export async function pageDeDemarrageAOuvrir() {
  if (!concerneParDemarrage()) return null
  const cle = 'keneya.demarrageVu.' + (store.state.user?.id ?? '')
  try {
    if (sessionStorage.getItem(cle)) return null
    sessionStorage.setItem(cle, '1')
  } catch (e) {
    return null
  }
  const d = await chargerDemarrage(true)
  return d?.resume?.obligatoiresRestantes > 0 ? routeDemarrage() : null
}
